var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgResources2Icon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26.464,
  height: 32.524,
  viewBox: "0 0 26.464 32.524"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#7654fd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.271 1.048 1.164 14.969a2.04 2.04 0 0 0 0 2.584l11.107 13.92a1.253 1.253 0 0 0 1.921 0l11.107-13.92a2.04 2.04 0 0 0 0-2.584L14.192 1.048a1.253 1.253 0 0 0-1.921 0",
  "data-name": "Path 272"
}), /*#__PURE__*/React.createElement("path", {
  d: "m.703 16.263 7.308 1.421h10.442l7.307-1.421",
  "data-name": "Path 273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.012 17.684 13.232.607l5.22 17.078-5.22 14.239Z",
  "data-name": "Path 274"
}))));
export default SvgResources2Icon;